import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import type { RdIndemnityPeriod } from '@/services/quotes/rd-equipamentos/types';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

/**
 * Prazos de indenização oferecíveis (`GET /config/indemnity-periods`).
 *
 * É cadastro de produto, não constante: desativar um prazo no admin tira-o da
 * matriz sem deploy. A ORDEM vem do motor (`sort_order`) e é a ordem em que os
 * botões devem ser desenhados.
 */
export function useRdIndemnityPeriods() {
  return useQuery<RdIndemnityPeriod[]>({
    queryKey: ['rd-indemnity-periods'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getIndemnityPeriods();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar os períodos indenitários'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
